import React from 'react';
import { useSelector } from 'react-redux';
import { Form, RadioGroup, Radio } from 'react-form';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { Select, CheckBox } from '../../../components/Form';
import { createReactFormValidator } from '../../../utils/validation';

import styles from '../nuoV2.scss';
import { NewUserOnboardingIDs } from '../../../components/Analytics/testIDConfig';
import { required, formHasErrors } from '../../../utils/form-validation';

const TennisSelfRatingForm = props => {
    const { handleSubmit } = props;

    const auth = useSelector(({ auth }) => {
        const { user: { utrRange, utrRangeRequired, birthdate } } = auth;
        return {
            auth: {
                user: {
                    utrRange,
                    utrRangeRequired,
                    birthdate,
                },
            },
        };
    });
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const onboarding = useSelector(({ onboarding }) => onboarding);

    const { types = {} } = coreUI;
    const { utrRange = {} } = types;
    const { frequencyTypes = [], levelTypes = [], matchTypes = [] } = utrRange;

    const { utrRangeSurvey: { saving, error } } = onboarding;
    const ageRestriction = {
        min: 3,
    };
    if (auth.user?.birthdate) {
        const currentAge = moment().diff(auth.user.birthdate, 'years');
        ageRestriction.max = currentAge;
    }

    const getAgeOptions = () => {
        const list = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 2; i <= 100; i++) {
            list.push({ id: i, label: i });
        }
        return list;
    };

    return (
        <div className={styles.page}>
            <Form onSubmit={values => handleSubmit(values)}>
                {({ submitForm, errors, getError, values }) => {
                    const frequencyError = getError('frequency');
                    const matchesCountError = getError('matchesCount');
                    const frequencyValue = values.frequency;
                    const matchesCountValue = values.matchesCount;
                    return (
                        <form onSubmit={submitForm} id="OnboardingSurveyForm" data-testid="nuo-v2.tennis-self-rating.form">
                            <div className="row mb24">
                                <div className="col-12">
                                    <div className={`fw500 mb8`} data-testid="nuo-v2.tennis-self-rating.level-types-label">
                                        What type or level of tennis have you played? (Select all that apply) *
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className={styles.input}>
                                        {levelTypes.map(({ id, label }) => (
                                            <CheckBox
                                                id={`levelType-${id}`}
                                                customLabel={label}
                                                field={`levelType-${id}`}
                                                formGroupCssClass="mb8"
                                                data-testid={`nuo-v2.tennis-self-rating.level-type-${id}`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-group ${styles.radioGroup} row mb24 ${frequencyError && 'is-invalid'}`}>
                                <div className="col-12">
                                    <RadioGroup
                                        field="frequency"
                                        validate={createReactFormValidator(required)}
                                        data-testid={`${NewUserOnboardingIDs.TennisFrequencyTypes.component}-${NewUserOnboardingIDs.TennisFrequencyTypes.location}-${NewUserOnboardingIDs.TennisFrequencyTypes.id}`}
                                    >
                                        <label className={'mb8 fw500'} data-testid="nuo-v2.tennis-self-rating.frequency-label">
                                            How often do you play? *
                                        </label>
                                        {frequencyTypes.map(({ id, label }) => (
                                            <div className="d-flex aic mb8" data-testid={`nuo-v2.tennis-self-rating.frequency-option-${id}`}>
                                                <Radio
                                                    key={`frequency-${id}`}
                                                    id={`frequency-${id}`}
                                                    value={id}
                                                    checked={frequencyValue === id}
                                                    data-testid={`nuo-v2.tennis-self-rating.frequency-option-${id}.input`}
                                                />
                                                <label htmlFor={`frequency-${id}`} className="mb0" data-testid={`nuo-v2.tennis-self-rating.frequency-option-${id}.label`}>&nbsp;{label}</label>
                                            </div>
                                        ))}
                                    </RadioGroup>
                                    {frequencyError && (
                                        <div className="text-error fs13" data-testid="nuo-v2.tennis-self-rating.frequency-error">
                                            This field is required.
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={`form-group ${styles.radioGroup} row mb24 ${matchesCountError && 'is-invalid'}`}>
                                <div className="col-12">
                                    <RadioGroup
                                        field="matchesCount"
                                        validate={createReactFormValidator(required)}
                                        data-testid={`${NewUserOnboardingIDs.TennisMatchTypes.component}-${NewUserOnboardingIDs.TennisMatchTypes.location}-${NewUserOnboardingIDs.TennisMatchTypes.id}`}
                                    >
                                        <label className={'mb8 fw500'} data-testid="nuo-v2.tennis-self-rating.matches-count-label">
                                            Approximately how many matches of 2 or more sets have you played in your lifetime? Please include practice matches *
                                        </label>
                                        {matchTypes.map(({ id, label }) => (
                                            <div className="d-flex aic mb8" data-testid={`nuo-v2.tennis-self-rating.matches-count-option-${id}`}>
                                                <Radio
                                                    key={`matchesCount-${id}`}
                                                    id={`matchesCount-${id}`}
                                                    value={id}
                                                    checked={matchesCountValue === id}
                                                    data-testid={`nuo-v2.tennis-self-rating.matches-count-option-${id}.input`}
                                                />
                                                <label htmlFor={`matchesCount-${id}`} className="mb0" data-testid={`nuo-v2.tennis-self-rating.matches-count-option-${id}.label`}>&nbsp;{label}</label>
                                            </div>
                                        ))}
                                    </RadioGroup>
                                    {matchesCountError && (
                                        <div className="text-error fs13" data-testid="nuo-v2.tennis-self-rating.matches-count-error">
                                            This field is required.
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb16">
                                    <label className={'fw500 mb0'} data-testid="nuo-v2.tennis-self-rating.age-started-label">
                                        What age did you start playing tennis? *
                                    </label>
                                </div>
                                <div className="col-12">
                                    <div className={styles.input}>
                                        <Select
                                            id="ageStarted"
                                            field="ageStarted"
                                            options={getAgeOptions()}
                                            validate={required}
                                            themeV3
                                            data-testid={`${NewUserOnboardingIDs.TennisAgeStarted.component}-${NewUserOnboardingIDs.TennisAgeStarted.location}-${NewUserOnboardingIDs.TennisAgeStarted.id}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            {formHasErrors(errors) && (
                                <div className="row mb16">
                                    <div className="col-12">
                                        <div className="pt24 text-center text-error text-small" data-testid="nuo-v2.tennis-self-rating.form-error">
                                            You must complete the survey to get a rating.
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!!error && (
                                <div className="row mb16">
                                    <div className="col-12">
                                        <div className="pt24 text-center text-error text-small" data-testid="nuo-v2.tennis-self-rating.api-error">
                                            Error submitting form. {error}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className={`col-12 text-center`}>
                                    <div className={styles.submit}>
                                        <button
                                            data-testid={`${NewUserOnboardingIDs.TennisSubmitButton.component}-${NewUserOnboardingIDs.TennisSubmitButton.location}-${NewUserOnboardingIDs.TennisSubmitButton.id}`}
                                            type="submit"
                                            className={`btn btn-primary text-uppercase`}
                                            disabled={saving}
                                        >
                                            {saving ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    );
};

export default withRouter(TennisSelfRatingForm);
